import { Styled } from "./styles";

interface BadgeProps {
  children: React.ReactNode;
}

export const Badge = ({ children }: BadgeProps) => {
  return <Styled>{children}</Styled>;
};
